var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-example"},[_c('d-province',{attrs:{"size":"large","value":_vm.value},on:{"update:value":function($event){_vm.value=$event},"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }